import { useStaleBuild, type UseStaleBuildOptions } from '~/hooks/useStaleBuild';
import { Button } from './buttons';

/**
 * [MCV-1948] Offers a reload when this tab is running an older build than the deployed one,
 * so a tab left open across a deploy stops calling routes the new build removed. Sits above
 * floating buttons (z-30) and below the toast layer (z-60); an open dialog (also z-50, portalled
 * after #root) paints over it, which is fine. The `role="status"` region stays mounted and only
 * its content appears, so screen readers announce it. `options` exists for tests; the app
 * mounts it bare.
 */
export const StaleBuildBanner = (options: UseStaleBuildOptions) => {
  const stale = useStaleBuild(options);
  return (
    <div role="status">
      {stale && (
        <div
          className="fixed bottom-4 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 flex-col items-center gap-3 rounded-lg border border-grey-900 bg-white p-4 text-left shadow-xl sm:flex-row sm:justify-between"
          data-cy="stale-build-banner"
        >
          <p className="text-sm text-content-primary">
            A new version of this app is available. Reload to get the latest changes.
          </p>
          <Button type="button" wrap onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      )}
    </div>
  );
};
